export const articles = {
  upper: {
    formal: {
      male: { nom: 'Ihr', gen: 'Ihres', dat: 'Ihrem', acc: 'Ihren' },
      female: { nom: 'Ihre', gen: 'Ihrer', dat: 'Ihrer', acc: 'Ihre' },
      neutral: { nom: 'Ihr', gen: 'Ihres', dat: 'Ihrem', acc: 'Ihr' },
      plural: { nom: 'Ihre', gen: 'Ihrer', dat: 'Ihren', acc: 'Ihre' }
    },
    informal: {
      male: { nom: 'Der', gen: 'Des', dat: 'Dem', acc: 'Den' },
      female: { nom: 'Die', gen: 'Der', dat: 'Der', acc: 'Die' },
      neutral: { nom: 'Das', gen: 'Des', dat: 'Dem', acc: 'Das' },
      plural: { nom: 'Die', gen: 'Der', dat: 'Den', acc: 'Die' }
    }
  },
  lower: {
    formal: {
      male: { nom: 'ihr', gen: 'ihres', dat: 'ihrem', acc: 'ihren' },
      female: { nom: 'ihre', gen: 'ihrer', dat: 'ihrer', acc: 'ihre' },
      neutral: { nom: 'ihr', gen: 'ihres', dat: 'ihrem', acc: 'ihr' },
      plural: { nom: 'ihre', gen: 'ihrer', dat: 'ihren', acc: 'ihre' }
    },
    informal: {
      male: { nom: 'der', gen: 'des', dat: 'dem', acc: 'den' },
      female: { nom: 'die', gen: 'der', dat: 'der', acc: 'die' },
      neutral: { nom: 'das', gen: 'des', dat: 'dem', acc: 'das' },
      plural: { nom: 'die', gen: 'der', dat: 'den', acc: 'die' }
    }
  }
};

export enum ArticleGender {
  male = 'male',
  female = 'female',
  neutral = 'neutral',
  plural = 'plural'
}

export enum ArticleCase {
  nom = 'nom',
  gen = 'gen',
  dat = 'dat',
  acc = 'acc'
}
